<template>
  <div class="login_config_info_wraper">
    <div class="login_config_text_title">智能控制系统</div>

    <div class="card_wraper login_wrap">
      <div class="login_title">
        <span class="title">登录</span>
        <router-link to="/register" class="go_register" replace>立即注册</router-link>
      </div>
      <div class="login_input_wrap">
        <div class="login_input">
          <span>账号：</span>
          <input
            class="input_text"
            type="text"
            placeholder="请输入账号/手机号"
            v-model="userinfo.id"
            onkeyup="value=value.replace(/[\u4e00-\u9fa5]/ig,'')"
          />
        </div>
        <div class="login_input">
          <span>密码：</span>
          <input
            class="input_text"
            type="password"
            placeholder="请输入密码"
            v-model="userinfo.passWord"
            autocomplete="new-password"
            onkeyup="value=value.replace(/[\u4e00-\u9fa5]/ig,'')"
          />
        </div>
      </div>
      <div class="login_tips_position">
        <router-link to="/mchangepassword" class="login_tips" replace>忘记密码?</router-link>
      </div>

      <div class="login_btn" @click="loginBtnClick">立即登录</div>
    </div>

    <div class="login_config_info">
      <div @click="yanShiBtnHandle">演示界面</div>
      <div @click="configServerIPBtnHandle">设置服务器</div>
      <div @click="gengDuoXuanXiangBtnHandle">隐私政策</div>
      <div @click="aboutPageBtnHandle">更多</div>

    </div>
  </div>
</template>

<script>
import { logiBtnHandle } from "common/beforeLogin/LoginPage";
////引入地图模块的js文件
// import getCurrentCityName from 'common/getUserLocation'
export default {
  components: {},
  data() {
    return {
      userinfo: {
        id: this.$store.state.userinfo.userId, /////绑定仓库里的ID信息,在初始化这个对象的时候就赋个初值给它
        passWord: ""
      }
      // location: null
    };
  },
  methods: {
    loginBtnClick() {
      logiBtnHandle(this.userinfo);
      // this.$store.dispatch('asyUpdataUserId','111')
      // // this.userinfo.id = this.$store.state.userinfo.userId;
    },
    aboutPageBtnHandle() {
      console.log("未登录关于按钮被点击了");
      // this.$router.push('/aboutPage')
      this.$router.push({ path: "/aboutPage", query: { type: "beforeLogin" } });
    },
    configServerIPBtnHandle() {
      console.log("配置服务器地址被点击了");
      this.$router.replace("/configServerIP");
    },
    gengDuoXuanXiangBtnHandle() {
      console.log("隐私政策被点击了");
      this.$router.push("/privacyPolicy");

      // this.$toast('暂未开放')
    },
    yanShiBtnHandle() {
      console.log("演示界面被点击了");
      this.$router.replace("/yanShiPage");
    },
    backgroundSelectState() {
      //背景的选择状态
      if (localStorage.getItem("backgroundSelectState") === null) {
        console.log("用户还没有设置背景");
        localStorage.setItem("backgroundSelectState", "1");
      }
      ////把本地缓存拿到浏览器缓存，方便调用
      sessionStorage.setItem(
        "backgroundSelectState",
        localStorage.getItem("backgroundSelectState")
      );
    },
    serveSelectState() {
      // 用户服务器地址的判断和初始化
      console.log(localStorage.getItem("userServeIp"));
      if (localStorage.getItem("selectServerState") === null) {
        console.log("还未设置服务器选项");
        localStorage.setItem("selectServerState", "system");
        localStorage.setItem("userServeIp", "");
      }
      ////把本地缓存拿到浏览器缓存，方便调用
      sessionStorage.setItem(
        "selectServerState",
        localStorage.getItem("selectServerState")
      );
      sessionStorage.setItem(
        "userServeIp",
        localStorage.getItem("userServeIp")
      );
    }
    //通过百度地图获取当前城市的方法
    // getCurrentCity() {
    //   getCurrentCityName()
    //     .then(city => {
    //       console.log(city) //顺利的话能在控制台打印出当前城市
    //       sessionStorage['positionCity'] = city /////获取的城市存入浏览器缓存
    //     })
    //     .catch(err => {
    //       console.log(err + ' 百度地图获取定位城市失败!')
    //     })
    // }
  },

  mounted() {
    // this.getCity()
    // this.getCurrentCity()
    console.log("111111111111111111");
    this.serveSelectState(); // 用户服务器地址的判断和初始化
    this.backgroundSelectState(); ///背景状态的初始化和判断
  }
};
</script>

<style>
.login_config_info_wraper {
  position: relative;
  top: 0;
  left: 50%;
  transform: translate(-50%, 0);

  max-width: 1200px;
  height: 100%;

  display: flex;
  flex-direction: column;
  flex-wrap: nowrap;
  justify-content: space-between;
  align-items: center;
}
.login_config_text_title {
  margin-top: 100px;
  font-size: 30px;
  /* height: 80px; */
}
.login_config_info {
  /* position: fixed; */
  width: 420px;
  height: 40px;
  margin-bottom: 20px;
  color: #666666;
  display: flex;
  justify-content: space-between;
  align-items: center;

  cursor: pointer;
  /* box-shadow: 0px 0 1px var(--primary-color); */
}
.input_text {
  /* 属性 聚焦时切换成英文输入法 */
  ime-mode: inactive;
}
.login_wrap {
  /* position: static;
  top: 0;
  left: 0;
  transform: none; */

  width: 400px;
  padding: 30px 60px;
}

.login_title {
  height: 50px;
  line-height: 50px;
  margin-bottom: 10px;
  text-align: center;
  position: relative;
}

.title {
  font-size: 28px;
}
.go_register {
  position: absolute;
  right: 0;
}
.login_input {
  margin-bottom: 20px;
}
.login_input input {
  width: 328px;
}

.login_input span {
  font-size: 18px;
}

.login_tips_position {
  position: relative;
  height: 30px;
  line-height: 30px;
  margin-bottom: 10px;
  margin-top: -18px;
}
.login_tips {
  position: absolute;
  right: 0px;
  color: #666;
  font-size: 14px;
  text-align: right;
  text-decoration: none;
}

.login_btn {
  height: 50px;
  line-height: 50px;
  text-align: center;
  border-radius: var(--primary-border-radius);
  background: var(--primary-color);
  font-size: 16px;
  color: #fff;
  cursor: pointer; /*移入时光标样式*/
}
</style>
